import { useState } from "react";

// Third Party
import { createFileRoute, useNavigate } from "@tanstack/react-router";

// UI
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

import { DatePicker } from "@/components/DatePicker";

import { DataTable } from "@/components/ui/data-table";

import { columns } from "@/modules/news/components/columns";
import type { News } from "@/modules/news/types";

// Icons
import { CirclePlus } from "lucide-react";

export const Route = createFileRoute("/_layout-private/news/")({
  component: NewComponent,
});

function NewComponent() {
  // Instance
  const navigate = useNavigate();

  // State
  const [filterDate, setFilterDate] = useState<Date | undefined>();

  const data: News[] = [
    {
      id: "728ed52f",
      title:
        "ສະຫຼຸບວຽກງານ 6 ເດືອນຕົ້ນປີ 2024 ແລະ ທິດທາງແຜນການປີ 2024 ຂອງ ຫ້ອງການກະຊວງການເງິນ",
      description: "Description",
      info_type_id: "728ed52f",
      background_url:
        "https://images.unsplash.com/photo-1527004013197-933c4bb611b3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=720&q=80",
      created_at: "2022-01-01",
      created_by: {
        first_name: "John",
        last_name: "Doe",
        role: {
          name: "Admin",
          description: "Admin",
        },
      },
      updated_at: "2022-01-01",
      updated_by: {
        first_name: "John",
        last_name: "Doe",
        role: {
          name: "Admin",
          description: "Admin",
        },
      },
    },
    {
      id: "728ed52f",
      title: "ໜ່ວຍຊາວໜຸ່ມກົມຄຸ້ມຄອງການບັນຊີ ດຳເນີນກອງປະຊຸມໃຫຍ່ ຄັ້ງທີ່IV",
      description: "Description",
      info_type_id: "728ed52f",
      background_url:
        "https://images.unsplash.com/photo-1527004013197-933c4bb611b3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=720&q=80",
      created_at: "2022-01-01",
      created_by: {
        first_name: "John",
        last_name: "Doe",
        role: {
          name: "Admin",
          description: "Admin",
        },
      },
      updated_at: "2024-07-08",
      updated_by: {
        first_name: "John",
        last_name: "Doe",
        role: {
          name: "Admin",
          description: "Admin",
        },
      },
    },
    // Add more payment objects as needed
  ];

  return (
    <section>
      <p className="text-[14px] mb-[32px]">ຈັດການຂໍ້ມູນຂ່າວສານ</p>

      <Card>
        <CardHeader>
          <CardTitle>ຂໍ້ມູນຂ່າວສານ</CardTitle>
          <CardDescription>ຕາຕະລາງຂໍ້ມູນຂ່າວສານທັງໝົດ</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-end justify-between">
            <div className="flex items-center gap-[8px] flex-wrap">
              <div>
                <Label htmlFor="">ຄົ້ນຫາ</Label>
                <Input placeholder="ຄົ້ນຫາຂ່າວສານ..." className="w-[500px]" />
              </div>

              <div>
                <Label htmlFor="" className="block py-1">
                  ວັນທີອັບເດດລ່າສຸດ
                </Label>
                <DatePicker selected={filterDate} onChange={setFilterDate} />
              </div>
            </div>
            <Button
              className="flex items-center gap-2"
              onClick={() =>
                navigate({
                  to: "/news/mutate",
                  search: {
                    id: undefined,
                    data: undefined,
                  },
                })
              }
            >
              <CirclePlus size={16} /> ເພີ່ມຂໍ້ມູນຂ່າວສານ
            </Button>
          </div>
          <div className="my-[16px]">
            <DataTable
              columns={columns}
              data={data}
              onRowClick={(row) =>
                navigate({
                  to: `/news/${row.id}`,
                  search: {
                    data: JSON.stringify(row),
                  },
                })
              }
            />
          </div>
        </CardContent>
        {/* <CardFooter>
					<p>Card Footer</p>
				</CardFooter> */}
      </Card>
    </section>
  );
}
